module.exports = __webpack_public_path__ + "img/Untitled-1-2-800x800.b63dc119.png";